module.exports = __webpack_public_path__ + "img/logo.83a1f221.png";